export interface IEntityToDisable {
    id: number;
    name: string;
    activeUntilDate?: Date;
    quantity?: number;
}

const newEntityToDisable = (): IEntityToDisable => ({
    id: 0,
    name: ''
})

export const createEntityToDisable = <T extends Partial<IEntityToDisable>>(initialValues: T): IEntityToDisable & T => {
    return Object.assign(newEntityToDisable(), initialValues);
};